import { ClientFile } from '../redux/reducers/clientFile'
import { fetchRequest } from '../services/http.service'

export const GET_CLIENT_FILE_URL = '/clientfile/'
export const POST_CLIENT_FILE_URL = '/clientfile'

export const getClientFilesRequest = (clientId: Number) => fetchRequest.get<ClientFile[]>(GET_CLIENT_FILE_URL + clientId)

export const postClientFileRequest = (iqBody: ClientFile[]) => fetchRequest.post<ClientFile[]>(POST_CLIENT_FILE_URL, iqBody)
